class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
        this.selector = this.dataset.selector;
        this.isTransitioning = false;
        this.defaultSpeed = this.options.speed || 1000;
        this.fastSpeed = 200;
    }

    connectedCallback() {
        const swiperElement = this.querySelector(`.swiper.${this.selector}`);
        if (!swiperElement) return;

        if (this.classList.contains('slideshow-banner-hp')) {
            this.initBannerSlider(swiperElement);
        } else {
            this.initSlider(swiperElement);
        }
    }

    initSlider(swiperElement) {
        if (typeof Swiper === 'undefined' || !swiperElement) return;

        this.swiperInstance = new Swiper(swiperElement, this.options);
    }

    initBannerSlider(swiperElement) {
        if (typeof Swiper === 'undefined' || !swiperElement) return;

        let checkSlides = setInterval(() => {
            if (!swiperElement) {
                clearInterval(checkSlides);
                return;
            }

            let slides = swiperElement.querySelectorAll('.swiper-slide[id]');
            if (!slides || slides.length === 0) return;

            clearInterval(checkSlides);

            if (this.options.loop === "true" && slides.length < 3) {
                this.duplicateSlides(swiperElement, 3);
            }

            this.swiperInstance = new Swiper(swiperElement, {
                ...this.options,
                navigation: {
                    nextEl: ".swiper-button-next-banner",
                    prevEl: ".swiper-button-prev-banner",
                },
                effect: "fade",
                speed: this.options.speed || 1000,
                on: {
                    slideChangeTransitionStart: () => {
                        this.isTransitioning = true;
                        this.fixDot(this.swiperInstance);
                        console.log(this.swiperInstance.realIndex);
                    },
                    slideChangeTransitionEnd: () => {
                        this.isTransitioning = false;
                        this.restoreSpeed();
                    }
                }
            });

            this.overrideNavigation();
            this.fixDot(this.swiperInstance);
        }, 100);
    }

    duplicateSlides(container, count) {
        if (!container) return;
        const slides = container.querySelectorAll('.swiper-slide[id]');
        if (!slides || slides.length === 0) return;

        for (let i = 0; i < count; i++) {
            let clone = slides[i % slides.length].cloneNode(true);
            clone.id = `clone-${i}`;
            container.querySelector('.swiper-wrapper')?.appendChild(clone);
        }
    }

    overrideNavigation() {
        const prevButton = document.querySelector('.swiper-button-prev-banner');
        const nextButton = document.querySelector('.swiper-button-next-banner');

        if (prevButton && nextButton && this.swiperInstance) {
            prevButton.addEventListener('click', () => this.forceSlideChange('prev'));
            nextButton.addEventListener('click', () => this.forceSlideChange('next'));
        }
    }

    forceSlideChange(direction) {
        if (this.isTransitioning || !this.swiperInstance) return;

        this.setFastSpeed();
        direction === 'next' ? this.swiperInstance.slideNext() : this.swiperInstance.slidePrev();
        setTimeout(() => this.fixDot(this.swiperInstance), 50);
    }

    setFastSpeed() {
        if (this.swiperInstance) {
            this.swiperInstance.params.speed = this.fastSpeed;
        }
    }

    restoreSpeed() {
        if (this.swiperInstance) {
            this.swiperInstance.params.speed = this.defaultSpeed;
        }
    }

    fixDot(swiperInstance) {
        if (!swiperInstance || !swiperInstance.el) return;
    
        const sliderElement = swiperInstance.el.closest('.swiper');
        if (!sliderElement) return;
    
        const dotsContainer = sliderElement.querySelector('.swiper-pagination-banner');
        if (!dotsContainer) return;
    
        dotsContainer.querySelectorAll('.swiper-pagination-bullet').forEach(dot => dot.classList.remove('swiper-pagination-bullet-active'));
    
        const activeBullet = dotsContainer.children[swiperInstance.realIndex];
        if (activeBullet) {
            activeBullet.classList.add('swiper-pagination-bullet-active');
        }
    }
}

customElements.define('swiper-slider', SwiperSlider);

class SwiperUtils {
    /**
     * @param {Object} swiper - The swiper instance to be updated.
     */
    static update(swiper){
        swiper.update();
    }
}